import { message }           from 'antd';
import type { FormInstance } from 'antd';
import { messageErrorIntl }  from 'utils/messageIntl';

const handleFormError = (error: any, form: FormInstance | null) => {
  if (error.connectorError && error.connectorError.response && error.connectorError.response.data) {
    if (error.connectorError.response.data.violations) {
      const errors: Record<string, any> = {};

      error.connectorError.response.data.violations.forEach((violation: any) => {
        const fieldsValue = form?.getFieldsValue() || {};
        if (!violation.propertyPath || !fieldsValue[violation.propertyPath]) {
          message.error(
            (violation.propertyPath ? `${violation.propertyPath} : ` : '') + violation.message,
          );
        } else {
          if (!errors[violation.propertyPath]) {
            errors[violation.propertyPath] = {
              errors: [],
              value: fieldsValue[violation.propertyPath], // if needed
            };
          }
          errors[violation.propertyPath].errors.push(violation.message);
        }
      });

      const errorsAsArray: any[] = [];
      Object.keys(errors).forEach(key => {
        errorsAsArray.push({
          errors: errors[key].errors,
          name: key,
        });
      });

      form?.setFields(errorsAsArray);
    } else if (error.connectorError.response.data['hydra:description']) {
      return message.error(error.connectorError.response.data['hydra:description']);
    } else {
      messageErrorIntl("Une erreur s'est produite.");
    }
  } else {
    messageErrorIntl("Une erreur s'est produite.");
  }
};

export default handleFormError;
